'use client';

import classes from './ProcessTimeline.module.scss';
import { IconSparkles, IconCheck } from '@tabler/icons-react';

type TimelineStep = {
  title: string;
  description: string;
  duration?: string;
  outcome?: string;
};

type ProcessTimelineProps = {
  badge?: string;
  title: string;
  subtitle?: string;
  steps: TimelineStep[];
};

export const ProcessTimeline = ({ data }: { data: ProcessTimelineProps }) => {
  const { badge, title, subtitle, steps } = data;

  return (
    <section className={classes.section} aria-labelledby="timeline-title">
      <div className={classes.container}>
        <div className={classes.header}>
          {badge && (
            <div className={classes.badgeWrapper}>
              <IconSparkles size={18} className={classes.badgeIcon} />
              <span className={classes.badge}>{badge}</span>
            </div>
          )}
          <h2 id="timeline-title" className={classes.title}>{title}</h2>
          {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
        </div>

        <div className={classes.timeline} role="list">
          {steps.map((step, index) => (
            <article key={`${step.title}-${index}`} className={classes.step} role="listitem">
              <div className={classes.stepConnector}>
                <div className={classes.stepBadge}>
                  <span className={classes.stepNumber}>{`0${index + 1}`}</span>
                  {index < steps.length - 1 && <div className={classes.stepLine} />}
                </div>
              </div>
              <div className={classes.stepBody}>
                <div className={classes.stepHeader}>
                  <h3 className={classes.stepTitle}>{step.title}</h3>
                  {step.duration && (
                    <span className={classes.stepDuration}>{step.duration}</span>
                  )}
                </div>
                <p className={classes.stepDescription}>{step.description}</p>
                {step.outcome && (
                  <div className={classes.stepOutcome}>
                    <IconCheck size={16} className={classes.outcomeIcon} />
                    <span>{step.outcome}</span>
                  </div>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

